import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesktopSearchPageComponent } from './desktop-search-page/desktop-search-page.component';
import { DesktopNotFoundPageComponent } from './desktop-not-found-page/desktop-not-found-page.component';
import { SharedServicesModule } from 'src/app/modules/shared-services/shared-services.module';
import { SharedComponentsModule } from 'src/app/modules/shared-components/shared-components.module';
import { SharedMaterialModule } from 'src/app/modules/shared-material/shared-material.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginDestkopComponent } from './login/login.component';
import { LoginButtonComponent } from './login/login-button/login-button.component';
import { WrongPasswordComponent } from './login/wrong-password/wrong-password.component';
import { WrongPasswordDialogComponent } from './login/wrong-password/wrong-password-dialog/wrong-password-dialog.component';
import { LoginDialogComponent } from './login/login-dialog/login-dialog.component';
import { CloseDialogButtonComponent } from './dialog/close-dialog-button/close-dialog-button.component';
import { StaticContentComponent } from './static-content/static-content.component';
import { HomeEssentialsComponent } from './home-essentials/home-essentials.component';
import { SupportFaqSelfTabComponent } from './support-faq-self-tab/support-faq-self-tab.component';
import { GameDialogComponent, GameDialogRouteComponent } from './dialog/game-dialog/game-dialog.component';
import { DesktopBannerComponent } from './home-essentials/desktop-banner/desktop-banner.component';
import { SwiperModule } from 'swiper/angular';
import { HomePageTournamentComponent } from './tournaments/home-page-tournament/home-page-tournament.component';
import { LaunchTournamentComponent } from './tournaments/launch-tournament/launch-tournament.component';
import { TournamentGamesComponent } from './tournaments/launch-tournament/tournament-games/tournament-games.component';
import { TournamentTabsComponent } from './tournaments/launch-tournament/tournament-tabs/tournament-tabs.component';
import { HowItWorksComponent } from './tournaments/launch-tournament/tournament-tabs/how-it-works/how-it-works.component';
import { PrizesScoringComponent } from './tournaments/launch-tournament/tournament-tabs/prizes-scoring/prizes-scoring.component';
import { LeaderBoardComponent } from './tournaments/launch-tournament/tournament-tabs/leader-board/leader-board.component';
import { PointsScoringComponent } from './tournaments/launch-tournament/tournament-tabs/points-scoring/points-scoring.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DesktopGameLauncherComponent } from './game-launcher/game-launcher.component';
import { TournamentsModule } from '../tournaments/tournaments.module';
import { DesktopPaymentHistoryComponent } from './desktop-payment-history/desktop-payment-history.component';
import { AllTournamentComponent } from './tournaments/all-tournament/all-tournament.component';
import { TeaserTopDesktopComponent } from './teaser-top-desktop/teaser-top-desktop.component';
import { RouterModule, Routes } from '@angular/router';
import { GreenJadeComponent } from './game-launcher/green-jade/green-jade/green-jade.component';
import { DesktopMenuModule } from '../../modules/desktop-menu/desktop-menu.module';
import { DESKTOP_MODULE_ROUTES } from './desktop.routing.module';
import {
  changePasswordTrx,
  clientAreaTrx,
  editProfileTrx,
  gameHistoryTrx,
  gameInfoTrx,
  gameTrx,
  inboxTrx,
  lastPlayedFullTrx,
  myGamesTrx,
  liveCasinoTrx,
  loginTrx,
  lostPasswordTrx,
  missionsTrx,
  paymentHistoryTrx,
  paymentTrx,
  pendingWithdrawalTrx,
  promotionsTrx,
  providerTrx,
  recommendationsTrx,
  searchGameTrx,
  signUpTrx,
  streamerTournamentTrx,
  supportTrx,
  tournamentsTrx,
  uploadDocumentsTrx,
  indiaLpTrx,
  faqTrx,
  selfExclusionTrx,
  pickBetTournamentTrx,
  reactivationTrx,
  referFriendTrx,
  christmasTrx
} from '../../router-translation.labels';
import { LoginDialogRouteComponent } from '../auth/login-dialog/login-dialog.component';
import { LostPasswordDialogRouteComponent } from '../auth/lost-password-dialog/lost-password-dialog.component';
import { NewPasswordComponent } from '../auth/new-password/new-password.component';
import { NotFoundPageResolver } from '../../resolvers/not-found-page.resolver';
import { DesktopSearchComponent } from './desktop-search/desktop-search.component';
import { AuthGuard } from '../../auth.guard';
import { LastPlayedFullComponent } from '../games/last-played-full/last-played-full.component';
import { ChangePasswordComponent } from '../auth/change-password/change-password.component';
import { PaymentHistoryComponent } from '../payment/payment-history/payment-history.component';
import { PendingWithdrawalListComponent } from '../payment/pending-withdrawal-list/pending-withdrawal-list.component';
import { AppModule } from '../../app.module';
import { TranslationConfig } from '../../utils/translate-config';
import { PAYMENT_MODULE_ROUTES_NOT_TRANSLATED } from '../../modules/payments/payments-routes';
import { DESKTOP_CATEGORIES_MODULE_NOT_TRANSLATED } from '../../modules/desktop-categories/desktop-categories-routes';
import { routerMapping } from '../../router-mapping';
import { DesktopGameOperatorsModule } from 'src/app/modules/desktop-operators/desktop-operators.module';
import { DesktopGameOperatorCategoryComponent } from './desktop-operator/desktop-operator.component';
import { RecommendationsFullComponent } from '../games/recommendations-full/recommendations-full.component';
import { AllMissionComponent } from './missions/all-tournament/all-mission.component';
import { MissionsCarouselDynamicModule } from '../missions/missions-carousel.dynamic.module';
import { MyGamesComponent } from '../games/my-games/my-games.component';
import { IndiaLandingPageComponent } from '../india-landing-page/india-landing-page.component';
import { LaunchMissionComponent } from './missions/launch-tournament/launch-missions.component';
import { MissionsModule } from "../missions/missions.module";
import { MissionTabsComponent } from './missions/launch-tournament/tournament-tabs/missions-tabs.component';
import { HomePageMissionsComponent } from './missions/home-page-missions/home-page-missions.component';
import { HowMissionWorksComponent } from './missions/launch-tournament/tournament-tabs/how-mission-works/how-mission-works.component';
import { MissionGamesComponent } from './missions/launch-tournament/missions-games/missions-games.component';
import { ReactivationModule } from '../reactivation/reactivation.module';
import { HomePageReactivationComponent } from '../reactivation/home-page-reactivation/home-page-reactivation.component';
import { SharedSearchModule } from 'src/app/modules/search/shared-search.module';
import { SearchMobileModule } from 'src/app/modules/search/search.module';
import { AppSwiperModule } from '../games/search-game/swiper-module/swiper.module';
import { DESKTOP_ROUTES } from '../../global.tokens';
import { XmasModule } from '../../components/xmas/xmas.module';
import { HomePagePromotionsComponent } from './info/home-page-promotions/home-page-promotions.component';
// import { HomePageXmasComponent } from '../xmas/home-page-xmas/home-page-xmas.component';

export const signupDialogRoute = {
  path: signUpTrx,
  loadChildren: () => import('../../modules/signup/signup-dialog.module').then(m => m.SignupDialogModule)
};

const paymentsRoutes = {
  path: paymentTrx,
  canLoad: [AuthGuard],
  loadChildren: () => import('../../modules/payments/payments.module').then(m => {
    const translateConfig = AppModule.mInjector.get(TranslationConfig);
    const desktopRoutes = AppModule.mInjector.get(DESKTOP_ROUTES);
    PAYMENT_MODULE_ROUTES_NOT_TRANSLATED
      .forEach(route => {
        route.path = translateConfig.translatePathElement(route);
        (desktopRoutes as Array<any>).push(route);
      });
    return m.PaymentsModule;
  })
};

const desktopSlotsRoutes = {
  path: `${gameTrx}/:category`,
  loadChildren: () => import('../../modules/desktop-categories/desktop-categories.module').then(m => {
    const translateConfig = AppModule.mInjector.get(TranslationConfig);
    const desktopRoutes = AppModule.mInjector.get(DESKTOP_ROUTES);
    DESKTOP_CATEGORIES_MODULE_NOT_TRANSLATED
      .forEach(route => {
        route.path = translateConfig.translatePathElement(route);
        (desktopRoutes as Array<any>).push(route);
      });
    return m.DesktopCategoriesModule;
  })
};

const missionsRoute = {
  path: missionsTrx,
  canActivate: [],
  loadChildren: () => import('../../components/missions/missions.module').then(m => m.MissionsModule)
};

const desktopProvidersRoutes = {
  path: `${providerTrx}/:category`,
  loadChildren: () => import('../../modules/desktop-categories/desktop-categories.module').then(m => {
    const translateConfig = AppModule.mInjector.get(TranslationConfig);
    const desktopRoutes = AppModule.mInjector.get(DESKTOP_ROUTES);
    DESKTOP_CATEGORIES_MODULE_NOT_TRANSLATED
      .forEach(route => {
        route.path = translateConfig.translatePathElement(route);
        (desktopRoutes as Array<any>).push(route);
      });
    return m.DesktopCategoriesModule;
  })
};

const desktopCategoriesMappingRoutes = Array.from(routerMapping).map(([trx, cat]) => {
  return {
    path: trx, loadChildren: () => import('../../modules/desktop-categories/desktop-categories.module')
      .then(m => m.DesktopCategoriesModule), data: { category: cat }
  };
});

const desktopLiveCasinoRoutes = [
  {
    path: liveCasinoTrx,
    loadChildren: () => import('../../modules/desktop-live-casino/desktop-live-casino.module').then(m => {
      const translateConfig = AppModule.mInjector.get(TranslationConfig);
      const desktopRoutes = AppModule.mInjector.get(DESKTOP_ROUTES);
      DESKTOP_MODULE_ROUTES_NOT_TRANSLATED
        .forEach(route => {
          route.path = translateConfig.translatePathElement(route);
          (desktopRoutes as Array<any>).push(route);
        });
      return m.DesktopLiveCasinoModule;
    })
  }
];

const streamerRoute = {
  path: streamerTournamentTrx,
  canActivate: [],
  loadChildren: () => import('../streamer-tournament/streamer-tournament.module').then((m) => { return m.StreamerTournamentModule })
};

const pickBetRoute = {
  path: pickBetTournamentTrx,
  canActivate: [],
  loadChildren: () => import('../pick-bet-tournament/pick-bet-tournament.module').then((m) => { return m.PickBetTournamentModule })
};

export const DESKTOP_MODULE_ROUTES_NOT_TRANSLATED: Routes = [
  {
    path: '', component: HomeEssentialsComponent, children: [
      signupDialogRoute,
      { path: loginTrx, component: LoginDialogRouteComponent },
      {
        path: lostPasswordTrx, component: LostPasswordDialogRouteComponent
      },
    ]
  },
  paymentsRoutes,
  { path: 'new-password', component: NewPasswordComponent },
  { path: supportTrx, component: SupportFaqSelfTabComponent, data: { tabIndex: 0 } },
  { path: faqTrx, component: SupportFaqSelfTabComponent, data: { tabIndex: 1 } },
  { path: selfExclusionTrx, component: SupportFaqSelfTabComponent, data: { tabIndex: 2 } },
  { path: promotionsTrx, loadChildren: () => import('../../modules/desktop-promotions/desktop-promotions.module').then(m => m.DesktopPromotionsModule) },
  { path: clientAreaTrx, canLoad: [AuthGuard], loadChildren: () => import('../../components/client-area/client-area.module').then(m => m.ClientAreaModule) },
  { path: searchGameTrx, component: DesktopSearchComponent },
  { path: editProfileTrx, loadChildren: () => import('../../modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule) },
  { path: providerTrx, component: DesktopGameOperatorCategoryComponent, data: { isAll: true } },
  desktopProvidersRoutes,
  desktopSlotsRoutes,
  ...desktopCategoriesMappingRoutes,
  ...desktopLiveCasinoRoutes,
  streamerRoute,
  pickBetRoute,
  {
    path: gameInfoTrx + '/:game', component: DesktopGameLauncherComponent, children: [
      { path: tournamentsTrx, canActivate: [], data: { isInGame: true }, loadChildren: () => import('../../components/tournaments/tournaments.module').then(m => m.TournamentsModule) },
      { path: missionsTrx, canActivate: [], data: { isInGame: true }, loadChildren: () => import('../../components/missions/missions.module').then(m => m.MissionsModule) },
      signupDialogRoute,
      { path: loginTrx, component: LoginDialogRouteComponent },
    ]
  },
  // {
  //   path: christmasCalendarTrx,
  //   loadChildren: () => import('../../components/calendar/calendar.module').then(m => m.CalendarModule),
  // },
  { path: tournamentsTrx + '/id/:index', component: LaunchTournamentComponent },
  { path: tournamentsTrx, component: AllTournamentComponent },
  { path: missionsTrx, component: AllMissionComponent },
  { path: missionsTrx + '/id/:index', component: LaunchMissionComponent },
  {
    path: paymentHistoryTrx, canActivate: [AuthGuard], component: DesktopPaymentHistoryComponent
  },
  missionsRoute,
  {
    path: inboxTrx,
    canActivate: [AuthGuard],
    loadChildren: () => import('../../modules/user-messages/user-messages.module').then(m => m.UserMessagesModule),
  },
  {
    path: lastPlayedFullTrx, component: LastPlayedFullComponent
  },
  {
    path: myGamesTrx, component: MyGamesComponent
  },
  {
    path: recommendationsTrx, component: RecommendationsFullComponent
  },
  {
    path: changePasswordTrx, component: ChangePasswordComponent, data: { skipLocationChange: true }
  },
  {
    path: paymentHistoryTrx, canActivate: [AuthGuard], component: PaymentHistoryComponent, children: [
    ], data: { skipLocationChange: true }
  },
  {
    path: indiaLpTrx,
    loadChildren: () => import('../../modules/india-landing-pages/india-landing-pages.module').then(m => m.IndiaLandingPagesModule),
  },
  {
    path: pendingWithdrawalTrx, component: PendingWithdrawalListComponent, children: [
    ]
  },
  {
    path: uploadDocumentsTrx, canActivate: [AuthGuard], loadChildren: () => import('../../components/profile/upload-documents/upload-documents.module').then(m => m.UploadDocumentsModule),
  },
  {
    path: reactivationTrx, canActivate: [AuthGuard], loadChildren: () => import('../../components/reactivation/reactivation.module').then(m => m.ReactivationModule),
  },
  {
    path: christmasTrx, canActivate: [AuthGuard], loadChildren: () => import('../../components/xmas/xmas.module').then(m => m.XmasModule),
  },
  {
    path: searchGameTrx, component: DesktopSearchComponent, data: { skipLocationChange: true }
  },
  {
    path: gameHistoryTrx,
    loadChildren: () => import('../../modules/game-history/game-history.module').then(m => m.GameHistoryModule),
  },
  {
    path: editProfileTrx, loadChildren: () => import('../../modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule)
  },
  {
    path: ':slug/:name', component: StaticContentComponent, resolve: { info: NotFoundPageResolver }
  },
  {
    path: referFriendTrx, loadChildren: () => import('../../modules/refer-friend/refer-friend.module').then((m) => m.ReferFriendModule)
  },
  { path: '**', pathMatch: 'full', component: DesktopNotFoundPageComponent },
];

@NgModule({
  declarations: [
    DesktopSearchPageComponent,
    DesktopNotFoundPageComponent,
    LoginDestkopComponent,
    LoginButtonComponent,
    WrongPasswordComponent,
    WrongPasswordDialogComponent,
    LoginDialogComponent,
    CloseDialogButtonComponent,
    StaticContentComponent,
    HomeEssentialsComponent,
    SupportFaqSelfTabComponent,
    GameDialogRouteComponent,
    GameDialogComponent,
    DesktopBannerComponent,
    HomePageTournamentComponent,
    HomePageMissionsComponent,
    HomePageReactivationComponent,
    // HomePageXmasComponent,
    HowMissionWorksComponent,
    LaunchTournamentComponent,
    LaunchMissionComponent,
    TournamentGamesComponent,
    MissionGamesComponent,
    TournamentTabsComponent,
    MissionTabsComponent,
    HowItWorksComponent,
    PrizesScoringComponent,
    LeaderBoardComponent,
    PointsScoringComponent,
    DesktopGameLauncherComponent,
    DesktopPaymentHistoryComponent,
    TeaserTopDesktopComponent,
    AllTournamentComponent,
    AllMissionComponent,
    GreenJadeComponent,
    DesktopSearchComponent,
    HomePagePromotionsComponent,
  ],
  providers: [],
  exports: [],
  imports: [
    RouterModule.forChild(DESKTOP_MODULE_ROUTES),
    CommonModule,
    SharedServicesModule,
    SharedComponentsModule,
    TournamentsModule,
    InfiniteScrollModule,
    SharedMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    DesktopMenuModule,
    DesktopGameOperatorsModule,
    MissionsModule,
    ReactivationModule,
    // XmasModule,
    SharedSearchModule,
    SearchMobileModule,
    AppSwiperModule
  ]
})
export class DesktopModule {

  public static routes = DESKTOP_MODULE_ROUTES_NOT_TRANSLATED;
  // constructor(
  //   private router: Router,
  // ) {
  //   console.log("router")
  //   debugger
  // }
}
